import { Flex, Box, TableContainer, Table, Thead, Tr, Th, Tbody } from '@chakra-ui/react';
import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

import ArrowLeftTable from 'components/Icons/ArrowLeftTable';
import ArrowRightTable from 'components/Icons/ArrowRightTable';
import { MONTH_NAMES, STATUS } from 'projectConstants';
import TabsFilter from 'pages/PlanPageOutputOptimization/Plan/Filters/TabsFilter';
import { getCalculationLoadingStatus, getSelectedDashboardScenario } from 'redux/DashboardSliceV2';

import PriviewFilterByComponent from '../PreviewFilterBy';

import DashboardTableRow from './DashboardTableRow';

export interface DashboardTableProperties {
  tableData: Array<any> | null;
  expandkey: string;
  timeGranularity: string;
  tableHeaderData: Array<any> | null;
  isDashboardLayout: boolean;
  setExpandKey: (value: string) => void;
  setTimeGranularity: (value: string) => void;
  handleApplyFilter: (value: string) => void;
  output: any;
  isDimensionFilter: Array<any>;
}
const DashboardTable = ({
  tableData,
  expandkey,
  timeGranularity,
  tableHeaderData,
  isDashboardLayout,
  setExpandKey,
  setTimeGranularity,
  handleApplyFilter,
  output,
  isDimensionFilter,
}: DashboardTableProperties) => {
  const calculationStatus = useSelector(getCalculationLoadingStatus);
  const scrollReference = useRef<HTMLDivElement | null>(null);
  const [actualTableHeaders, setActualTableHeaders] = useState<any>(null);
  const [actualTableData, setActualTableData] = useState<Array<any>>([]);

  const baseScenario: any = useSelector(getSelectedDashboardScenario);

  const startDateObject = new Date(baseScenario?.start_date);
  startDateObject.setMonth(startDateObject.getMonth() - 1);
  const appliedFilters: any = [];
  const timeAggregation: string = 'M';
  const yearFormat = `FY${startDateObject.getFullYear().toString().slice(-2)}`;

  const quarterFormat = `Q${Math.ceil((startDateObject.getMonth() + 1) / 3)}-${String(
    yearFormat,
  ).slice(-2)}`;

  const monthFormat = `${MONTH_NAMES[startDateObject.getMonth()]}-${String(yearFormat).slice(-2)}`;
  const chartFilter = 'M';
  const targetDate = () => {
    if (chartFilter === 'M') {
      return monthFormat;
    }
    if (chartFilter === 'Q') {
      return quarterFormat;
    }
    return yearFormat;
  };

  const expand = (value: any) => {
    if (value.isShowExpandable && timeAggregation !== 'Y') {
      setExpandKey(value.Time !== expandkey ? value.Time : '');
    } else if (value.isShowExpandable && timeGranularity !== 'Y') {
      if (expandkey !== value.Time && (timeGranularity === 'Y' || timeGranularity === 'Q')) {
        setExpandKey(value.Time);
      } else {
        setExpandKey('');
      }
    }
  };

  const dimensionFilters = (payload: any) => {
    const dimensionTableData = payload || [];
    if (
      appliedFilters?.length > 0 &&
      dimensionTableData?.length > 0 &&
      dimensionTableData?.[0]?.dims?.[0]
    ) {
      const hasDims = dimensionTableData[0]?.dims[0]?.Time;
      const dimensionIndex = appliedFilters?.findIndex((data: any) => {
        const object = Object.keys(data);
        return object[0] === hasDims;
      });
      const results = dimensionTableData?.map((data: any) => {
        if (data?.dims && data?.dims?.length && hasDims && appliedFilters[dimensionIndex]) {
          const filteredData = data?.dim_df?.filter((item: any) => {
            return appliedFilters[dimensionIndex][hasDims]?.includes(item?.Time?.trim());
          });
          return { ...data, dim_df: filteredData };
        }
        return data;
      });
      const sortedData = results?.sort((a: any, b: any) => {
        const positionA = a?.indicator?.position ?? 0;
        const positionB = b?.indicator?.position ?? 0;
        return positionA - positionB;
      });
      setActualTableData(sortedData);
    } else {
      const sortedData = dimensionTableData?.sort((a: any, b: any) => {
        const positionA = a?.indicator?.position ?? 0;
        const positionB = b?.indicator?.position ?? 0;
        return positionA - positionB;
      });
      setActualTableData(sortedData);
    }
  };

  useEffect(() => {
    if (tableHeaderData) {
      const actualDate = targetDate();
      const actualTableHeaderNew = [];
      let afterFlag = false;
      // setDataHadActualValue(false);
      for (let index = tableHeaderData.length - 1; index >= 0; index -= 1) {
        const item = JSON.parse(JSON.stringify(tableHeaderData[index]));
        if (item.Time === `${actualDate}`) {
          afterFlag = true;
          // setDataHadActualValue(true);
        }
        item.isActualValue = afterFlag;
        actualTableHeaderNew.push(item);
      }
      setActualTableHeaders(actualTableHeaderNew.reverse());
    }
  }, [timeGranularity, tableHeaderData]);

  useEffect(() => {
    if (tableData) {
      const actualTableDataNew = [];
      const actualDate = targetDate();
      // eslint-disable-next-line unicorn/no-for-loop
      for (let index = 0; index < tableData.length; index += 1) {
        const item = JSON.parse(JSON.stringify(tableData[index]));
        const totalValues = [];
        let afterFlag = false;
        for (let indexOne = item.total.length - 1; indexOne >= 0; indexOne -= 1) {
          const itemValue = JSON.parse(JSON.stringify(item.total[indexOne]));
          if (itemValue.Time === `${actualDate}`) {
            afterFlag = true;
          }
          itemValue.isActualValue = afterFlag;
          totalValues.push(itemValue);
        }
        item.total = totalValues.reverse();
        item.dim_df = item.dim_df?.map((dimValue: any) => {
          const dimValues = [];
          let flagNew = false;

          if (item?.dim_df) {
            for (let indexTwo = item.dim_df.length - 1; indexTwo >= 0; indexTwo -= 1) {
              const itemValue = JSON.parse(JSON.stringify(item.dim_df[indexTwo]));
              if (itemValue.Time === `${actualDate}`) {
                flagNew = true;
              }
              itemValue.isActualValue = flagNew;
              dimValues.push(itemValue);
            }
          }

          item.dim_df = dimValues.reverse();
          return dimValue;
        });
        actualTableDataNew.push(item);
      }
      dimensionFilters(actualTableDataNew);
    }
  }, [timeGranularity, tableData]);

  useEffect(() => {
    if (scrollReference.current && actualTableHeaders) {
      const scrollContainer = scrollReference.current;
      const targetIndex = actualTableHeaders.findIndex((header: any) => !header.isActualValue) - 1;
      if (targetIndex !== -1) {
        const targetElement = scrollContainer.querySelector(
          `th[data-index="${targetIndex}"]`,
        ) as HTMLElement;
        if (targetElement) {
          const { offsetLeft, offsetTop } = targetElement;
          scrollContainer.scrollTo({
            top: offsetTop - 250,
            left: offsetLeft - 250,
            behavior: 'smooth',
          });
        }
      }
    }
  }, [actualTableHeaders]);

  return (
    <Flex borderRadius='15px' flexDirection='column' gap={1} height='100%'>
      <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} m={1}>
        <Flex>
          {isDimensionFilter && (
            <PriviewFilterByComponent widget={output} handleApplyFilter={handleApplyFilter} />
          )}
        </Flex>
        <Flex>
          {timeGranularity && (
            <TabsFilter
              timeGranularity={timeGranularity}
              onChangeSummeryMode={setTimeGranularity}
              fontColor={'#787878'}
              bg={'#F7F7F815'}
              color='white'
              selectedYear='all'
              isDisabled={
                !(calculationStatus === STATUS.SUCCESS || calculationStatus === STATUS.IDLE)
              }
            />
          )}
        </Flex>
      </Flex>

      {/* flex={1} + minH={0} lets this box fill the remaining card height without
          JS measurement, so the table behaves correctly both on the dashboard grid
          and inside the instrument editor modal. */}
      <Box px={4} flex={1} minH={0}>
        {actualTableHeaders && (
          <Box
            ref={scrollReference}
            borderRadius='10px'
            overflowY='auto'
            overflowX='auto'
            h='100%'
            className='scroll'
          >
            <TableContainer
              overflowY='unset'
              overflowX='unset'
              mb={{ base: 4.75, md: 0 }}
              mt={{ base: 0, md: 0 }}
              borderRadius='10px'
              className='table_scroll indicator-table dashboard-drag-header'
              cursor='grab'
            >
              <Table variant='base'>
                {/* The base table theme (table.theme.ts) handles:
                    - thead:  position:sticky top:0 zIndex:20 bgColor:green.800
                    - th._first: position:sticky top:0 left:0 zIndex:10 bgColor:green.800
                    - td._first: position:sticky left:0 bgColor:white.900
                    So no manual sticky props are needed here; the theme supplies them.
                    The corner Th gets a true frozen corner because table.theme.ts now
                    sets both top:0 and left:0 on th._first. */}
                {/* zIndex={2} keeps the header above sticky body first-column cells
                    (td._first uses zIndex:1 in DashboardTableRow) while staying
                    well below Chakra menu/modal portals (z≥1000). */}
                <Thead height={'9'} zIndex={2}>
                  <Tr>
                    {/* Blank corner cell — theme's th._first applies sticky top+left. */}
                    <Th
                      textAlign={'left'}
                      fontFamily={'regular_roboto'}
                      fontSize={'xs'}
                      fontWeight={500}
                      textTransform='none'
                    >
                      {''}
                    </Th>
                    {actualTableHeaders?.map(
                      (date: any, index: number) =>
                        date.isShow && (
                          <Th
                            data-index={index}
                            background={date?.isActualValue ? '#4AB7BF' : undefined}
                            fontFamily={'regular_roboto'}
                            fontSize={'xs'}
                            fontWeight={500}
                            textTransform='none'
                            style={{
                              cursor: date.isShowExpandable ? 'pointer' : 'default',
                              paddingRight: '1rem',
                            }}
                            onClick={() => {
                              expand(date);
                            }}
                            key={index}
                            textAlign={'center'}
                          >
                            {date.isShowExpandable}
                            {date.isShowExpandable &&
                              (expandkey === date.Time ? <ArrowRightTable /> : <ArrowLeftTable />)}
                            {date.Time}
                          </Th>
                        ),
                    )}
                  </Tr>
                </Thead>

                {actualTableData && (
                  <Tbody>
                    {actualTableData?.map((row: any, index: number) => (
                      <React.Fragment key={index}>
                        <DashboardTableRow
                          isDashboardLayout={isDashboardLayout}
                          key={row.id}
                          row={row}
                          expandkey={expandkey}
                        />
                      </React.Fragment>
                    ))}
                  </Tbody>
                )}
              </Table>
            </TableContainer>
          </Box>
        )}
      </Box>
    </Flex>
  );
};
export default DashboardTable;
